import { Stack, Box } from '@mui/material';
import { LabsSelect } from './LabsSelect';
import { FacilitySelect } from './FacilitySelect';

export const LabsAndFacilitySelect = ({ disabled = false }) => {
  return (
    <Stack direction="row" width="100%">
      <Box width="50%">
        <LabsSelect disabled={disabled} />
      </Box>
      <Box width="50%" marginLeft="-1px">
        <FacilitySelect disabled={disabled} />
      </Box>
    </Stack>
  );
};
